/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import throttle from 'lodash.throttle';
export function useScrollPosition(containerRef) {
    const [scrollPosition, setScrollPosition] = useState('start');
    const updateScrollPosition = () => {
        if (!containerRef.current)
            return;
        const { width } = containerRef.current.getBoundingClientRect();
        const { scrollLeft, scrollWidth } = containerRef.current;
        if (scrollWidth < width) {
            setScrollPosition('none');
            return;
        }
        if (scrollLeft === 0) {
            setScrollPosition('start');
            return;
        }
        if (scrollLeft + width >= scrollWidth) {
            setScrollPosition('end');
            return;
        }
        setScrollPosition('middle');
    };
    useEffect(() => {
        if (!containerRef.current)
            return;
        containerRef.current.addEventListener('scroll', updateScrollPosition);
        return () => { var _a; return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', updateScrollPosition); };
    }, [containerRef.current]);
    useEffect(() => {
        if (!containerRef.current)
            return;
        const resizeObserverCallback = throttle(updateScrollPosition, 50);
        const resizeObserver = new ResizeObserver(resizeObserverCallback);
        resizeObserver.observe(containerRef.current);
        return () => resizeObserver.disconnect();
    }, [containerRef.current]);
    return { scrollPosition, containerRef };
}
//# sourceMappingURL=useScrollPosition.js.map